import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const userResendConfirmFn = (data) =>
  apiClient.post(`${APP_SSO_URL}api/full-service/user/resend-confirm`, data);

export const useUserResendConfirmMutation = () => {
  return useMutation({
    mutationFn: userResendConfirmFn,
  });
};
